<div class="col-12">
  <div class="card">
    <div class="card-header card-header-grey">
      <h4 class="card-title">
        Statut de mon compte
      </h4>
    </div>

    <div *ngIf="isActive" class="mat-card-content">
      <div class="row" style="margin-top:1rem;">
        <div class="col-12 text-center">
          <i class="fas fa-check fa-4x fa-rose"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <h3><b>Votre compte est actif</b></h3>
          <p>Il peut être consulté par les recruteurs</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <input style="margin-right:1rem;" type="button" class="btn btn-next btn-fill btn-rose btn-wd" name="next" value="Désactiver mon compte"
              matTooltip="Les recruteurs n'auront plus accès à votre dossier"
              matTooltipPosition="above"
                 (click)="desactivation()">
          <input type="button" class="btn btn-next btn-fill btn-rose btn-wd" name="next" value="Supprimer mon compte"
              matTooltip="Toutes vos données seront supprimées"
              matTooltipPosition="above"
                 (click)="suppression()">
        </div>
      </div>
    </div>

    <div *ngIf="!isActive" class="mat-card-content">
      <div class="row" style="margin-top:1rem;">
        <div class="col-12 text-center">
          <i class="fas fa-times fa-4x fa-rose"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <h3><b>Votre compte est désactivé</b></h3>
          <p>Il ne peut pas être consulté par les recruteurs</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <input style="margin-right:1rem;" type="button" class="btn btn-next btn-fill btn-rose btn-wd" name="next" value="Activer mon compte"
                 matTooltip="Les recruteurs auront accès à votre dossier"
                 matTooltipPosition="above"
                 (click)="activation()">
          <input type="button" class="btn btn-next btn-fill btn-rose btn-wd" name="next" value="Supprimer mon compte"
              matTooltip="Toutes vos données seront supprimées"
              matTooltipPosition="above"
                 (click)="suppression()">
        </div>
      </div>
    </div>

  </div>
</div>
